import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Dropdown } from "react-bootstrap";
import { AuthContext } from "../../context/AuthContext";
import "../../styles/Header.css"; // Import du fichier CSS moderne
import logo from '../../assets/logo.png';  
 
const Header = () => {
  const { currentUser, logout } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(
    currentUser?.profile.role === "admin" || false
  );
  useEffect(() => {
    if (currentUser) {
      setIsAdmin(currentUser.profile.role === "admin");
    }
  }, [currentUser]);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Fonction pour basculer le menu mobile
  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  // Navigation principale
  const MainNavigation = () => (
    <div className={`main-navigation ${showMobileMenu ? "show" : ""}`}>
      
      <Link
        to={isAdmin ? "/admin" : "/"}
        className="nav-link"
        onClick={() => setShowMobileMenu(false)}
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Accueil</span>
      </Link>
      <Link
        to={isAdmin ? "/admin/dictionary" : "/dictionary"}
        className="nav-link"
        onClick={() => setShowMobileMenu(false)}
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Termes</span>
      </Link>
      
      <Link
        to={isAdmin ? "/admin/projects" : "/projects"}
        className="nav-link"
        onClick={() => setShowMobileMenu(false)}
      >
        <span className="nav-icon"></span>
        <span className="nav-text">Projets</span>
      </Link>
      <Dropdown className="nav-dropdown">
        <Dropdown.Toggle as="div" className="nav-link modern-btn contribuer-link">
          <span className="nav-icon"></span>
          <span className="nav-text">Contribuer</span>
          <span className="dropdown-arrow">▼</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="contribuer-dropdown">
          <Dropdown.Header className="dropdown-header">
            <span className="header-icon">💡</span>
            Façons de contribuer
          </Dropdown.Header>
          <Dropdown.Item
            as={Link}
            to="/dictionary/add"
            className="contribute-item"
          >
            <div className="contribute-icon">📝</div>
            <div className="contribute-content">
              <div className="contribute-title">Ajouter un terme</div>
              <div className="contribute-desc">Enrichissez le dictionnaire</div>
            </div>
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to="/projects/new"
            className="contribute-item"
          >
            <div className="contribute-icon">🎯</div>
            <div className="contribute-content">
              <div className="contribute-title">Proposer un projet</div>
              <div className="contribute-desc">Partagez vos idées</div>
            </div>
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            as={Link}
            to="/guide-contribution"
            className="guide-link"
          >
            <span className="guide-icon">📖</span>
            Guide de contribution
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );

  // Notifications
  const NotificationDropdown = () => (
    <Dropdown className="notification-dropdown-wrapper">
      <Dropdown.Toggle
        as="button"
        className="notification-toggle modern-btn"
        id="notification-dropdown"
      >
        <div className="notification-bell">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C13.1 2 14 2.9 14 4C14 4.1 14 4.2 14 4.3C16.3 5.2 18 7.4 18 10V16L20 18V19H4V18L6 16V10C6 7.4 7.7 5.2 10 4.3C10 4.2 10 4.1 10 4C10 2.9 10.9 2 12 2ZM10 21C10 22.1 10.9 23 12 23S14 22.1 14 21" />
          </svg>
          <span className="notification-badge pulse">3</span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="notification-menu">
        <div className="notification-header">
          <h6 className="notification-title">Notifications</h6>
          <button className="mark-all-read">Tout marquer lu</button>
        </div>
        <div className="notification-list">
          <Dropdown.Item className="notification-item unread">
            <div className="notification-content">
              <div className="notification-avatar bg-primary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 12L11 14L15 10M21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12Z" />
                </svg>
              </div>
              <div className="notification-body">
                <div className="notification-message">
                  Votre entrée a été validée
                </div>
                <div className="notification-time">Il y a 3 heures</div>
              </div>
            </div>
            <div className="unread-dot"></div>
          </Dropdown.Item>
          <Dropdown.Item className="notification-item unread">
            <div className="notification-content">
              <div className="notification-avatar bg-info">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 22C9 22 3 16 3 11V7L11 3L19 7V11C19 16 13 22 13 22L12 23L11 22C11 22 9 22 9 22Z" />
                </svg>
              </div>
              <div className="notification-body">
                <div className="notification-message">
                  Un commentaire sur votre entrée
                </div>
                <div className="notification-time">Il y a 1 jour</div>
              </div>
            </div>
            <div className="unread-dot"></div>
          </Dropdown.Item>
          <Dropdown.Item className="notification-item">
            <div className="notification-content">
              <div className="notification-avatar bg-success">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M5 16L3 5L8.5 12L18 4L19 6L8.5 19L5 16Z" />
                </svg>
              </div>
              <div className="notification-body">
                <div className="notification-message">
                  Bienvenue sur DzWörtnet!
                </div>
                <div className="notification-time">Il y a 3 jours</div>
              </div>
            </div>
          </Dropdown.Item>
        </div>
        <div className="notification-footer">
          <Link to="/notifications" className="view-all-link">
            Voir toutes les notifications
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );

  // Profil utilisateur
  const UserProfileDropdown = () => (
    <Dropdown className="user-dropdown-wrapper">
      <Dropdown.Toggle
        as="div"
        className="user-profile modern-profile"
        id="user-dropdown"
      >
        <div className="user-avatar-container">
          {currentUser.profile_image ? (
            <img
              src={currentUser.profile_image}
              alt="Avatar"
              className="user-avatar"
            />
          ) : (
            <div className="user-avatar user-avatar-initial">
              {(currentUser.first_name || currentUser.username || "?")
                .charAt(0)
                .toUpperCase()}
            </div>
          )}
          <div className="online-status"></div>
        </div>
        <div className="user-info d-none d-md-block">
          <span className="user-name">
            {currentUser.first_name || currentUser.username}
          </span>
          <small className="user-email">{currentUser.email}</small>
        </div>
        <div className="profile-arrow d-none d-md-block">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 10L12 15L17 10H7Z" />
          </svg>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="profile-menu">
        <div className="profile-header">
          <div className="profile-info">
            {currentUser.profile_image ? (
              <img
                src={currentUser.profile_image}
                alt="Avatar"
                className="profile-avatar-large"
              />
            ) : (
              <div className="profile-avatar-large user-avatar-initial">
                {(currentUser.first_name || currentUser.username || "?")
                  .charAt(0)
                  .toUpperCase()}
              </div>
            )}
            <div className="profile-details">
              <div className="profile-name">
                {currentUser.first_name || currentUser.username}
              </div>
              <div className="profile-email">{currentUser.email}</div>
            </div>
          </div>
        </div>
        <Dropdown.Divider />
        <Dropdown.Item
          as={Link}
          to={isAdmin ? "/Admin/profil" : "/profil"}
          className="profile-menu-item"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 4C14.2 4 16 5.8 16 8C16 10.2 14.2 12 12 12C9.8 12 8 10.2 8 8C8 5.8 9.8 4 12 4ZM12 14C16.4 14 20 15.8 20 18V20H4V18C4 15.8 7.6 14 12 14Z" />
          </svg>
          <span>Mon profil</span>
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to="/mes-contributions"
          className="profile-menu-item"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" />
          </svg>
          <span>Mes contributions</span>
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/parametres" className="profile-menu-item">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5ZM19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.97 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.51 2.42L9.13 5.07C8.52 5.32 7.96 5.66 7.44 6.05L4.95 5.05C4.72 4.96 4.46 5.05 4.34 5.27L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11.02C4.53 11.34 4.5 11.67 4.5 12C4.5 12.33 4.53 12.66 4.57 12.98L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.95C7.96 18.35 8.52 18.68 9.13 18.93L9.51 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.28 19.04 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98Z" />
          </svg>
          <span>Paramètres</span>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={logout}
          className="profile-menu-item logout-item"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" />
          </svg>
          <span>Se déconnecter</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  // Header pour utilisateur non connecté
  if (!currentUser) {
    return (
      <Navbar className="custom-navbar modern-navbar" expand="lg">
        <div className="navbar-container">
          <div className="navbar-left">
            <Link to="/" className="navbar-brand modern-brand">
              <img src={logo} alt="Logo" className="logo" />
              <span className="brand-text d-none d-sm-inline">DzWörtnet</span>
            </Link>
            <button
              className="mobile-toggle modern-toggle d-lg-none"
              onClick={toggleMobileMenu}
              aria-label="Toggle navigation"
            >
              <span className="toggle-line"></span>
              <span  className="toggle-line"></span>
              <span className="toggle-line"></span>
            </button>
            <MainNavigation />
          </div>
          <div className="navbar-right">
            <Link to="/login" className="login-button modern-login-btn">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M10 17V14H3V10H10V7L15 12L10 17Z" />
              </svg>
              <span>Se connecter</span>
            </Link>
          </div>
        </div>
      </Navbar>
    );
  }

  // Header pour utilisateur connecté
  return (
    <Navbar className="custom-navbar modern-navbar authenticated" expand="lg">
      <div className="navbar-container">
        <div className="navbar-left">
          <Link to={isAdmin ? "/admin" : "/"} className="navbar-brand modern-brand">
            <img src={logo} alt="Logo" className="logo" />
            <span className="brand-text d-none d-sm-inline">DzWörtnet</span>
          </Link>
          <button
            className="mobile-toggle modern-toggle d-lg-none"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            <span className="toggle-line"></span>
            <span className="toggle-line"></span>
            <span className="toggle-line"></span>
          </button>
          <MainNavigation />
        </div>
        <div className="navbar-right">
          <NotificationDropdown />
          <UserProfileDropdown />
        </div>
      </div>
    </Navbar>
  );
};

export default Header;